import React from 'react';
import { colors } from '../../../theme';
import { usePlayheadValue } from '../../hooks/use-playhead-value';

type TimelinePlayheadProps = {
  pxPerSecond: number;
  startOffset: number;
  onScrubStart?: (e: React.MouseEvent) => void;
};

const HANDLE_SIZE = 12;

export const TimelinePlayhead: React.FC<TimelinePlayheadProps> = ({ pxPerSecond, startOffset, onScrubStart }) => {
  const time = usePlayheadValue();
  const position = (time / 1000) * pxPerSecond + startOffset;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: position,
        pointerEvents: 'none',
        zIndex: 5
      }}
    >
      {/* Vertical line: 1px wide, centered on x=0 of the container. */}
      <div
        style={{
          position: 'absolute',
          top: 14,
          left: 0,
          transform: 'translateX(-50%)',
          width: 1,
          bottom: 0,
          backgroundColor: colors.playhead
        }}
      />
      {/* Handle: clickable, centered on x=0. `pointerEvents: 'auto'` overrides the parent. */}
      <div
        onMouseDown={onScrubStart}
        style={{
          position: 'absolute',
          top: 6,
          left: 0,
          transform: 'translateX(-50%)',
          width: HANDLE_SIZE,
          height: HANDLE_SIZE,
          borderRadius: '50%',
          backgroundColor: colors.playheadHandle,
          border: `2px solid ${colors.surfaceElevated}`,
          pointerEvents: onScrubStart ? 'auto' : 'none',
          cursor: onScrubStart ? 'grab' : 'default'
        }}
      />
    </div>
  );
};
